import { useTranslation } from '@crehana/i18n';

import { locales, type TKeys, WHATSAPP_TEMPLATES_PAGE_KEY } from '../i18n';

export const useAddResourceBundleWhatsappTemplates = () => {
  const { addResourceBundle } = useTranslation<TKeys>(
    WHATSAPP_TEMPLATES_PAGE_KEY,
  );

  addResourceBundle(locales);
};
